import { render, staticRenderFns } from "./FusionColumn2d.vue?vue&type=template&id=6858a56a&scoped=true"
import script from "./FusionColumn2d.vue?vue&type=script&lang=js"
export * from "./FusionColumn2d.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6858a56a",
  null
  
)

export default component.exports